import React from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import BaseModal from "./baseModal/BaseModal";
import { toast } from "react-toastify";
import { CONTENT_BLOCK } from "./baseModal/FieldTypes";

class ShareOnlineLinkModal extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  textToCopy = `https://dreamschools.daily.co/${this.props.roomName}`;

  handleCopyClick = () => {
    navigator.clipboard
      .writeText(this.textToCopy)
      .then(() => {
        toast.success("Link copied to clipboard!");
      })
      .catch(err => {
        toast.error("Failed to copy link to clipboard.");
      });
  };

  getBaseModalFields = () => {
    const roomLink = {
      type: CONTENT_BLOCK,
      data: {
        name: "Copy and paste the link below:",
        content: `https://dreamschools.daily.co/${this.props.roomName}`,
        textStyles: {
          overflowWrap: "break-word",
          wordBreak: "break-all"
        }
      }
    };

    const copyButton = {
      type: CONTENT_BLOCK,
      data: {
        content: (
          <button className="copyclipboard" onClick={this.handleCopyClick}>
            Copy to clipboard
          </button>
        )
      }
    };

    const fields = [];

    fields.push(roomLink);
    fields.push(copyButton);

    return fields;
  };

  getBaseModalProps = () => {
    return {
      title: "Share Online Link",
      fields: this.getBaseModalFields(),
      height: "300px",
      midSectionHeight: "52vh",
      handleClose: () => this.props.onClose()
    };
  };

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(ShareOnlineLinkModal);
